import React from 'react';

interface AnimatedBorderButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const AnimatedBorderButton: React.FC<AnimatedBorderButtonProps> = ({ 
  children, 
  onClick,
  className = ''
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        relative
        group
        inline-flex
        items-center
        justify-center
        whitespace-nowrap
        w-full md:w-auto 
        px-8 py-3
        rounded-full 
        font-medium 
        text-white
        overflow-hidden
        transition-all 
        duration-300
        hover:scale-105
        ${className}
      `}
    >
      {/* Animated gradient background */}
      <div 
        className="
          absolute 
          inset-0 
          bg-gradient-to-r 
          from-cyan-400 
          via-blue-400
          to-cyan-400 
          bg-[length:200%_auto]
          animate-[gradientBorder_3s_ease-in-out_infinite]
        "
      />

      {/* Glass effect overlay */}
      <div className="
        absolute 
        inset-0 
        bg-white/10 
        backdrop-blur-[1px]
        opacity-0
        group-hover:opacity-100
        transition-opacity
        duration-300
      "/>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center font-bold">
        {children}
      </div>
    </button>
  );
};

export default AnimatedBorderButton;